<template>
    <div>
        <div v-if="passed_filter">
            <div class="designeroption" data-designer-component-id="measurements">
                <h3>Measurements</h3>
                <div class="designer-floating-sidebar-message" v-if="floating_sidebar_message">
                    <i class="fa fa-circle-question"></i>
                    <span v-html="floating_sidebar_message"></span>
                </div>
                <div class="stylesoption">
                    <div :class="['form-group', !valid_door ? 'has-error' : '']" v-show="showWidthAndHeightText">
                        <label :class="[!valid_door ? 'text-danger' : '']">Door Width x Height</label>
                        <p class="form-control-static"><span
                            :class="[!valid_door_width ? 'text-danger' : '']">{{ door_width }}mm</span> x <span
                            :class="[!valid_door_height ? 'text-danger' : '']">{{ door_height }}mm</span>
                        </p>
                    </div>
                    <div :class="['form-group', !valid_door ? 'has-error' : '']" v-show="showWidthAndHeightText">
                        <label :class="[!valid_door ? 'text-danger' : '']">Slab Width x Height</label>
                        <p class="form-control-static"><span
                            :class="[!valid_door_width ? 'text-danger' : '']">{{ slab_width }}mm</span> x <span
                            :class="[!valid_door_height ? 'text-danger' : '']">{{ slab_height }}mm</span>
                        </p>
                    </div>
                    <div v-for="measurement in measurements"
                         :class="['form-group mt-6', localTarget[measurement.slug] === undefined || localTarget[measurement.slug] > limits[measurement.slug].max || localTarget[measurement.slug] < limits[measurement.slug].min ? 'has-error' : 'has-success']">
                        <label :for="component_id + '_' + measurement.slug">{{ measurement.title }}
                            <template v-if="loading">(Checking Min/Max...)</template>
                            <template v-if="!loading">({{ limits[measurement.slug].min }}mm to
                                {{ limits[measurement.slug].max }}mm)
                            </template>
                        </label>
                        <input :dusk="measurement.slug" :id="component_id + '_' + measurement.slug" type="number"
                               v-model="localTarget[measurement.slug]" class="form-control"
                               :placeholder="measurement.title" min="{{ limits[measurement.slug].min }}"
                               max="{{ limits[measurement.slug].max }}" pattern="[0-9]" @keydown="filterKey"
                               @input="filterInput">
                        <em v-if="show_message(measurement.slug, this.frameId)" class="txt-sm txt-light">
                            {{ show_message(measurement.slug, this.frameId) }}
                        </em>
                    </div>
                    <div v-if="extra_text" class="mt-3">
                        {{ extra_text }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import DesignerQuestionMeasurements from "../DesignerQuestionMeasurements.vue";
import {nextTick} from "vue";

export default {
    mixins: [
        DesignerQuestionMeasurements
    ],
    props: {
        extra_text: {
            default() {
                return '';
            }
        },
        cutToSize: {
            default() {
                return false;
            },
        },
        panelDesigner: {
            default() {
                return false;
            },
        },
        showWidthAndHeightText: {
            default() {
                return true;
            },
        },
    },
    methods: {
        show_message(slug, frame) {
            return ''; // disable messages
            if (slug === 'top_box_drop' || slug === 'right_width' || slug === 'left_width') {
                return 'Including any add on profiles';
            } else if (slug === 'flag_height') {
                return 'Including any add on or sill profiles';
            } else if (slug === 'overall_width') {
                return 'Including any add on profiles';
            } else if (slug === 'overall_height') {
                return 'Including any add on or sill profiles';
            }
            return false;
        },
        enter_max_sizes(set_to_null) {
            if (!this.cutToSize) {
                this.localTarget.overall_height = this.limits.overall_height.max.toString();
                this.localTarget.overall_width = this.limits.overall_width.max.toString();
            } else {
                if (set_to_null) {
                    this.localTarget.overall_height = null;
                    this.localTarget.overall_width = null;
                }
            }
        },
    },
    watch: {
        'cutToSize': {
            handler: function (val, oldVal) {
                if (this.panelDesigner) {
                    this.enter_max_sizes(true);
                }
            },
        },
        'slab': {
            handler: function (val, oldVal) {
                if (this.panelDesigner) {
                    this.enter_max_sizes(false);
                }
            },
        },
    },
    mounted() {
        var vueThis = this;
        nextTick(() => {
            vueThis.enter_max_sizes();
        });

        window.emitter.on('limits-updated', (limits) => {
            // @TODO 2025 upgrade cant do this, limits is computed, not sure how to fix
            // this.limits = limits;
            var vueThis = this;
            nextTick(() => {
                if (vueThis.panelDesigner) {
                    vueThis.enter_max_sizes(false);
                }
            });
        })

    },
    onUnmounted() {
        window.emitter.off('limits-updated')
    },
}
</script>
